import React, { useState, useEffect } from 'react';
import DataTable from '../../components/DataTable';
import { projectsAPI, clientsAPI } from '../../lib/api';

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [projectsRes, clientsRes] = await Promise.all([
        projectsAPI.getAll(),
        clientsAPI.getAll()
      ]);
      setProjects(projectsRes.data);
      setClients(clientsRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getClientName = (clientId) => {
    const client = clients.find(c => c.id === clientId);
    return client?.name || 'Internal';
  };

  const columns = [
    { key: 'name', label: 'Project Name' },
    { key: 'client_id', label: 'Client', render: (val) => getClientName(val) },
    { key: 'budget', label: 'Budget', type: 'currency' },
    { key: 'progress', label: 'Progress', type: 'percentage' },
    { key: 'start_date', label: 'Start Date', type: 'date' },
    { key: 'status', label: 'Status', type: 'status' },
  ];

  const formFields = [
    { name: 'name', label: 'Project Name', required: true, placeholder: 'Enter project name' },
    {
      name: 'client_id',
      label: 'Client',
      type: 'select',
      options: [{ value: '', label: 'Internal Project' }, ...clients.map(c => ({ value: c.id, label: c.name }))],
    },
    { name: 'description', label: 'Description', type: 'textarea', placeholder: 'Project description' },
    { name: 'start_date', label: 'Start Date', type: 'date' },
    { name: 'end_date', label: 'End Date', type: 'date' },
    { name: 'budget', label: 'Budget', type: 'number', defaultValue: 0 },
    { name: 'progress', label: 'Progress (%)', type: 'number', defaultValue: 0 },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      defaultValue: 'planning',
      options: [
        { value: 'planning', label: 'Planning' },
        { value: 'in_progress', label: 'In Progress' },
        { value: 'on_hold', label: 'On Hold' },
        { value: 'completed', label: 'Completed' },
        { value: 'cancelled', label: 'Cancelled' },
      ],
    },
  ];

  const handleAdd = async (data) => {
    await projectsAPI.create(data);
    fetchData();
  };

  const handleEdit = async (id, data) => {
    await projectsAPI.update(id, data);
    fetchData();
  };

  const handleDelete = async (id) => {
    await projectsAPI.delete(id);
    fetchData();
  };

  return (
    <DataTable
      title="Projects"
      description="Manage your projects"
      data={projects}
      columns={columns}
      formFields={formFields}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      loading={loading}
    />
  );
};

export default Projects;
